import { render, staticRenderFns } from "./uploadTopics.vue?vue&type=template&id=4e4c0945&scoped=true"
import script from "./uploadTopics.vue?vue&type=script&lang=js"
export * from "./uploadTopics.vue?vue&type=script&lang=js"
import style0 from "./uploadTopics.vue?vue&type=style&index=0&id=4e4c0945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c0945",
  null
  
)

export default component.exports